"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AllianceValidatorInfo = exports.QueuedUndelegation = exports.Undelegation = exports.Delegation = exports.protobufPackage = void 0;
/* eslint-disable */
const long_1 = __importDefault(require("long"));
const minimal_1 = __importDefault(require("protobufjs/minimal"));
const coin_1 = require("../../cosmos/base/v1beta1/coin");
const params_1 = require("./params");
exports.protobufPackage = "alliance.alliance";
const baseDelegation = {
    delegatorAddress: "",
    validatorAddress: "",
    denom: "",
    shares: "",
    lastRewardClaimHeight: long_1.default.UZERO,
};
exports.Delegation = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.delegatorAddress !== "") {
            writer.uint32(10).string(message.delegatorAddress);
        }
        if (message.validatorAddress !== "") {
            writer.uint32(18).string(message.validatorAddress);
        }
        if (message.denom !== "") {
            writer.uint32(26).string(message.denom);
        }
        if (message.shares !== "") {
            writer.uint32(34).string(message.shares);
        }
        for (const v of message.rewardHistory) {
            params_1.RewardHistory.encode(v, writer.uint32(42).fork()).ldelim();
        }
        if (!message.lastRewardClaimHeight.isZero()) {
            writer.uint32(48).uint64(message.lastRewardClaimHeight);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseDelegation);
        message.rewardHistory = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.delegatorAddress = reader.string();
                    break;
                case 2:
                    message.validatorAddress = reader.string();
                    break;
                case 3:
                    message.denom = reader.string();
                    break;
                case 4:
                    message.shares = reader.string();
                    break;
                case 5:
                    message.rewardHistory.push(params_1.RewardHistory.decode(reader, reader.uint32()));
                    break;
                case 6:
                    message.lastRewardClaimHeight = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        var _a;
        const message = Object.assign({}, baseDelegation);
        message.delegatorAddress =
            object.delegatorAddress !== undefined && object.delegatorAddress !== null
                ? String(object.delegatorAddress)
                : "";
        message.validatorAddress =
            object.validatorAddress !== undefined && object.validatorAddress !== null
                ? String(object.validatorAddress)
                : "";
        message.denom =
            object.denom !== undefined && object.denom !== null
                ? String(object.denom)
                : "";
        message.shares =
            object.shares !== undefined && object.shares !== null
                ? String(object.shares)
                : "";
        message.rewardHistory = ((_a = object.rewardHistory) !== null && _a !== void 0 ? _a : []).map((e) => params_1.RewardHistory.fromJSON(e));
        message.lastRewardClaimHeight =
            object.lastRewardClaimHeight !== undefined &&
                object.lastRewardClaimHeight !== null
                ? long_1.default.fromString(object.lastRewardClaimHeight)
                : long_1.default.UZERO;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.delegatorAddress !== undefined &&
            (obj.delegatorAddress = message.delegatorAddress);
        message.validatorAddress !== undefined &&
            (obj.validatorAddress = message.validatorAddress);
        message.denom !== undefined && (obj.denom = message.denom);
        message.shares !== undefined && (obj.shares = message.shares);
        if (message.rewardHistory) {
            obj.rewardHistory = message.rewardHistory.map((e) => e ? params_1.RewardHistory.toJSON(e) : undefined);
        }
        else {
            obj.rewardHistory = [];
        }
        message.lastRewardClaimHeight !== undefined &&
            (obj.lastRewardClaimHeight = (message.lastRewardClaimHeight || long_1.default.UZERO).toString());
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e;
        const message = Object.assign({}, baseDelegation);
        message.delegatorAddress = (_a = object.delegatorAddress) !== null && _a !== void 0 ? _a : "";
        message.validatorAddress = (_b = object.validatorAddress) !== null && _b !== void 0 ? _b : "";
        message.denom = (_c = object.denom) !== null && _c !== void 0 ? _c : "";
        message.shares = (_d = object.shares) !== null && _d !== void 0 ? _d : "";
        message.rewardHistory = ((_e = object.rewardHistory) !== null && _e !== void 0 ? _e : []).map((e) => params_1.RewardHistory.fromPartial(e));
        message.lastRewardClaimHeight =
            object.lastRewardClaimHeight !== undefined &&
                object.lastRewardClaimHeight !== null
                ? long_1.default.fromValue(object.lastRewardClaimHeight)
                : long_1.default.UZERO;
        return message;
    },
};
const baseUndelegation = { delegatorAddress: "", validatorAddress: "" };
exports.Undelegation = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.delegatorAddress !== "") {
            writer.uint32(10).string(message.delegatorAddress);
        }
        if (message.validatorAddress !== "") {
            writer.uint32(18).string(message.validatorAddress);
        }
        if (message.balance !== undefined) {
            coin_1.Coin.encode(message.balance, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseUndelegation);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.delegatorAddress = reader.string();
                    break;
                case 2:
                    message.validatorAddress = reader.string();
                    break;
                case 3:
                    message.balance = coin_1.Coin.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseUndelegation);
        message.delegatorAddress =
            object.delegatorAddress !== undefined && object.delegatorAddress !== null
                ? String(object.delegatorAddress)
                : "";
        message.validatorAddress =
            object.validatorAddress !== undefined && object.validatorAddress !== null
                ? String(object.validatorAddress)
                : "";
        message.balance =
            object.balance !== undefined && object.balance !== null
                ? coin_1.Coin.fromJSON(object.balance)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.delegatorAddress !== undefined &&
            (obj.delegatorAddress = message.delegatorAddress);
        message.validatorAddress !== undefined &&
            (obj.validatorAddress = message.validatorAddress);
        message.balance !== undefined &&
            (obj.balance = message.balance
                ? coin_1.Coin.toJSON(message.balance)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = Object.assign({}, baseUndelegation);
        message.delegatorAddress = (_a = object.delegatorAddress) !== null && _a !== void 0 ? _a : "";
        message.validatorAddress = (_b = object.validatorAddress) !== null && _b !== void 0 ? _b : "";
        message.balance =
            object.balance !== undefined && object.balance !== null
                ? coin_1.Coin.fromPartial(object.balance)
                : undefined;
        return message;
    },
};
const baseQueuedUndelegation = {};
exports.QueuedUndelegation = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.entries) {
            exports.Undelegation.encode(v, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueuedUndelegation);
        message.entries = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.entries.push(exports.Undelegation.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        var _a;
        const message = Object.assign({}, baseQueuedUndelegation);
        message.entries = ((_a = object.entries) !== null && _a !== void 0 ? _a : []).map((e) => exports.Undelegation.fromJSON(e));
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.entries) {
            obj.entries = message.entries.map((e) => e ? exports.Undelegation.toJSON(e) : undefined);
        }
        else {
            obj.entries = [];
        }
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseQueuedUndelegation);
        message.entries = ((_a = object.entries) !== null && _a !== void 0 ? _a : []).map((e) => exports.Undelegation.fromPartial(e));
        return message;
    },
};
const baseAllianceValidatorInfo = {};
exports.AllianceValidatorInfo = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.globalRewardHistory) {
            params_1.RewardHistory.encode(v, writer.uint32(10).fork()).ldelim();
        }
        for (const v of message.totalDelegatorShares) {
            coin_1.DecCoin.encode(v, writer.uint32(18).fork()).ldelim();
        }
        for (const v of message.validatorShares) {
            coin_1.DecCoin.encode(v, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseAllianceValidatorInfo);
        message.globalRewardHistory = [];
        message.totalDelegatorShares = [];
        message.validatorShares = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.globalRewardHistory.push(params_1.RewardHistory.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.totalDelegatorShares.push(coin_1.DecCoin.decode(reader, reader.uint32()));
                    break;
                case 3:
                    message.validatorShares.push(coin_1.DecCoin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        var _a, _b, _c;
        const message = Object.assign({}, baseAllianceValidatorInfo);
        message.globalRewardHistory = ((_a = object.globalRewardHistory) !== null && _a !== void 0 ? _a : []).map((e) => params_1.RewardHistory.fromJSON(e));
        message.totalDelegatorShares = ((_b = object.totalDelegatorShares) !== null && _b !== void 0 ? _b : []).map((e) => coin_1.DecCoin.fromJSON(e));
        message.validatorShares = ((_c = object.validatorShares) !== null && _c !== void 0 ? _c : []).map((e) => coin_1.DecCoin.fromJSON(e));
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.globalRewardHistory) {
            obj.globalRewardHistory = message.globalRewardHistory.map((e) => e ? params_1.RewardHistory.toJSON(e) : undefined);
        }
        else {
            obj.globalRewardHistory = [];
        }
        if (message.totalDelegatorShares) {
            obj.totalDelegatorShares = message.totalDelegatorShares.map((e) => e ? coin_1.DecCoin.toJSON(e) : undefined);
        }
        else {
            obj.totalDelegatorShares = [];
        }
        if (message.validatorShares) {
            obj.validatorShares = message.validatorShares.map((e) => e ? coin_1.DecCoin.toJSON(e) : undefined);
        }
        else {
            obj.validatorShares = [];
        }
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c;
        const message = Object.assign({}, baseAllianceValidatorInfo);
        message.globalRewardHistory = ((_a = object.globalRewardHistory) !== null && _a !== void 0 ? _a : []).map((e) => params_1.RewardHistory.fromPartial(e));
        message.totalDelegatorShares = ((_b = object.totalDelegatorShares) !== null && _b !== void 0 ? _b : []).map((e) => coin_1.DecCoin.fromPartial(e));
        message.validatorShares = ((_c = object.validatorShares) !== null && _c !== void 0 ? _c : []).map((e) => coin_1.DecCoin.fromPartial(e));
        return message;
    },
};
if (minimal_1.default.util.Long !== long_1.default) {
    minimal_1.default.util.Long = long_1.default;
    minimal_1.default.configure();
}
